import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { NAV_LINKS, SERVICES, CONTACT } from "../data/content";

export const Footer = () => (
    <footer className="border-t border-white/10 bg-[#08080A]" data-testid="site-footer">
        <div className="mx-auto grid max-w-7xl gap-14 px-6 py-20 lg:grid-cols-12 lg:px-10">
            <div className="lg:col-span-4">
                <div className="flex items-center gap-3">
                    <img
                        src="/assets/logo-alzira.png"
                        alt="Transportes Alzira"
                        className="h-12 w-12 rounded-full"
                    />
                    <span className="font-display text-lg font-black uppercase tracking-wide">
                        Transportes Alzira
                    </span>
                </div>
                <p className="mt-6 max-w-xs font-display text-2xl font-bold uppercase leading-tight text-zinc-400">
                    Transporte que move{" "}
                    <span className="text-brand">projetos.</span>
                </p>
                <p className="mt-6 font-mono text-xs uppercase tracking-[0.3em] text-zinc-600">
                    Transportes Alzira, Lda. — Desde 1998
                </p>
            </div>
            <div className="lg:col-span-2">
                <h3 className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-500">
                    Navegação
                </h3>
                <ul className="mt-6 space-y-3">
                    {NAV_LINKS.map((l) => (
                        <li key={l.to}>
                            <Link
                                to={l.to}
                                data-testid={`footer-link-${l.label.toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "")}`}
                                className="text-sm text-zinc-400 transition-colors duration-300 hover:text-brand"
                            >
                                {l.label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="lg:col-span-3">
                <h3 className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-500">
                    Serviços
                </h3>
                <ul className="mt-6 space-y-3">
                    {SERVICES.map((s) => (
                        <li key={s.id}>
                            <Link
                                to="/servicos"
                                data-testid={`footer-service-${s.id}`}
                                className="text-sm text-zinc-400 transition-colors duration-300 hover:text-brand"
                            >
                                {s.title}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="lg:col-span-3">
                <h3 className="font-mono text-xs uppercase tracking-[0.3em] text-zinc-500">
                    Contactos
                </h3>
                <ul className="mt-6 space-y-4 text-sm text-zinc-400">
                    <li>
                        <a
                            href={CONTACT.phoneHref}
                            data-testid="footer-phone"
                            className="flex items-center gap-3 transition-colors duration-300 hover:text-brand"
                        >
                            <Phone className="h-4 w-4 text-brand" />
                            {CONTACT.phone}
                        </a>
                    </li>
                    <li>
                        <a
                            href={`mailto:${CONTACT.email}`}
                            data-testid="footer-email"
                            className="flex items-center gap-3 transition-colors duration-300 hover:text-brand"
                        >
                            <Mail className="h-4 w-4 text-brand" />
                            {CONTACT.email}
                        </a>
                    </li>
                    <li className="flex items-start gap-3">
                        <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
                        <span>
                            {CONTACT.address}
                            <br />
                            {CONTACT.locality}
                        </span>
                    </li>
                </ul>
            </div>
        </div>
        <div className="border-t border-white/10">
            <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-6 py-6 font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-600 sm:flex-row lg:px-10">
                <span>© {new Date().getFullYear()} Transportes Alzira, Lda.</span>
                <div className="flex gap-6">
                    <Link to="/privacidade" data-testid="footer-privacy" className="transition-colors duration-300 hover:text-white">
                        Política de Privacidade
                    </Link>
                    <Link to="/cookies" data-testid="footer-cookies" className="transition-colors duration-300 hover:text-white">
                        Política de Cookies
                    </Link>
                    <Link to="/termos" data-testid="footer-terms" className="transition-colors duration-300 hover:text-white">
                        Termos e Condições
                    </Link>
                </div>
            </div>
        </div>
    </footer>
);
